import { Injectable } from '@angular/core';
import { User } from '../../models/user/user.interface';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpParamObject, HttpUtilityService } from '@edassist/api';
import { catchError, shareReplay } from 'rxjs/operators';
import { UserResults } from '../../models/user/user-results.interface';
import { LocalStorageService, constants } from '@edassist/common';

@Injectable({ providedIn: 'root' })
export class UserService {
	private readonly relativeUrl = 'users/';
	private cachedUsersByType$: Observable<UserResults>;

	constructor(private readonly http: HttpClient) {}

	getUserByParticipantId(participantId: number): Observable<User> {
		return this.http.get<User>(
			`${this.relativeUrl}/by-participantId/${participantId.toString()}`
		);
	}

	getUsersByUserType(
		index = 1,
		recordsPerPage = 10,
		userTypeIds: Array<number>
	): Observable<UserResults> {
		const queryParams: HttpParamObject = HttpUtilityService.toPlainHttpParams({
			userTypeId: userTypeIds.join(','),
			index,
			recordsPerPage
		});

		if (!this.cachedUsersByType$) {
			this.cachedUsersByType$ = this.http
				.get<UserResults>(`${this.relativeUrl}user-types`, queryParams)
				.pipe(shareReplay(1));
		}

		return this.cachedUsersByType$;
	}

	getUser(userId: number): Observable<User> {
		return this.http.get<User>(`${this.relativeUrl}${userId}`);
	}

	updateUser(userId: number, user: User): Observable<any> {
		return this.http.put<any>(`${this.relativeUrl}${userId}`, user)
		.pipe(catchError(() => of(undefined)));
	}

	getImpersonationEnabled(): boolean  {
		return !!LocalStorageService.getItem(constants.localStorageKeys.IMPERSONATION_USER);
	}
}
